import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";
import {
  urlMeetingAllSecured,
  urlMeetingSecured,
  urlMeetingAllAllSecured,
  urlExportMeetingSecured,
} from "../../api/urls";
import { PAGE_SIZE_10 } from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";
  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
    if (filters.farm !== undefined) filter += "&farm=" + filters.farm;
    if (filters.courseUuid !== undefined)
      filter += "&courseUuid=" + filters.courseUuid;
    if (filters.startDate !== undefined)
      filter += "&startDate=" + filters.startDate;
    if (filters.endDate !== undefined) filter += "&endDate=" + filters.endDate;
    if (filters.month !== undefined) filter += "&month=" + filters.month;
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

const generateFilterQueryAll = ({ filters, sort }) => {
  let filter = "?";

  if (filters) {
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
    if (filters.farm !== undefined) filter += "&farm=" + filters.farm;
    if (filters.courseUuid !== undefined)
      filter += "&courseUuid=" + filters.courseUuid;
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

/**
 * Filter list meetings.
 */
export const filterMeeting = createAction("FILTER_ITEMS", (filter, param) =>
  apiGet(urlMeetingAllSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Get a meeting.
 */
export const get = createAction("GET_MEETING", (param) =>
  apiGet(urlMeetingSecured, param, true)()
);

/**
 * Create meeting.
 */
export const createMeeting = createAction("REGISTER_MEETING", (obj) =>
  apiPost(urlMeetingSecured, obj, undefined, true)()
);

/**
 * Update meeting.
 */
export const update = createAction("UPDATE_MEETING", (obj, param) =>
  apiPut(urlMeetingSecured, param, obj, true)()
);

/**
 * Delete meeting.
 */
export const removeMeeting = createAction("DELETE_MEETING", (param) =>
  apiDelete(urlMeetingSecured, param, true)()
);

/**
 * Filter list meetings.
 */
export const filterMeetingAll = createAction(
  "FILTER_ITEMS_ALL",
  (filter, param) =>
    apiGet(
      urlMeetingAllAllSecured + generateFilterQueryAll(filter),
      param,
      true
    )()
);

export const listMeetingToExport = createAction(
  "EXPORT_FILTER_MEETING",
  (filter, param) =>
    apiGet(urlExportMeetingSecured + generateFilterQuery(filter), param, true)()
);
